/*
 * File: MessageCard.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 2:39 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Components
import { Card } from '../Card';


/**
 * Styles
 */

export const Wrapper = styled(Card)`
	padding: 10px 24px 14px;
	position: relative;
	overflow: hidden;

	${({ $isPlaceholder }) => $isPlaceholder && css`
		pointer-events: none;

		* {
			pointer-events: none;
		}
	`}
`;

export const CardHeader = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	margin: 0px 0px 2px;
`;

export const PromptContainer = styled.div`
	flex-grow: 1;
	display: flex;
	align-items: center;
	gap: 8px;

	h5 {
		text-transform: uppercase;
		font-size: 0.7rem;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: 2px 0px 8px;
	gap: 6px;

	span {
		cursor: pointer;
	}

	.rightIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-right: 4px;
		}
		& > span {
			margin: 0px;
		}
	}
	.leftIcon {
		svg {
			font-size: 0.7rem;
		}
		span {
			font-size: 0.8rem;
			margin-left: 6px;
		}
		& > span {
			margin: 0px;
		}
	}
`;

export const ActionBar = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin: 14px 0px 0px;
	align-items: center;

	.love {
		font-size: 1.0rem;
	}
	.comment {
		font-size: 1.0rem;
	}
	.active {
		color: ${({ theme }) => theme.brandHighlight}
	}
`;

export const ActionSpacer = styled.div`
	flex-grow: 1;
`;

export const TriggerWarning = styled.div`
	background-color: ${({ theme }) => theme.statusWarningLighter};
	border: 1px solid ${({ theme }) => theme.statusWarningBase};
	padding: 5px 9px 5px 9px;
    border-radius: 8px;
	margin: 12px 0px 0px;

	p {
		color: ${({ theme }) => theme.statusWarningBase};
	}
`;

export const SurvivorBadge = styled.div`
	background-color: ${({ theme }) => theme.brandPrimaryBase};
	color: ${({ theme }) => theme.white};
	padding: 3px 9px;
	display: flex;
	align-items: center;
	border-radius: 10px;
	gap: 3px;

	span {
		font-size: 0.65rem;
		margin: 0px;
	}
	svg {
		font-size: 0.65rem;
	}
`;
